import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'locationFormat',
    standalone: true,
})
export class LocationFormatPipe implements PipeTransform {
    transform(location: string): unknown {
        return location?.replace(', Nederland', '');
    }
}
